import { Component, Input } from "@angular/core";
@Component({
    selector: "together-auction-dip-tooltip",
    templateUrl: "./dip.tooltip.component.html",
    standalone: false
})
export class TogetherAuctionDIPTooltipComponent {
  @Input() mobWidth: any;

  @Input() title: string;
  @Input() id: string;
  @Input() placement: string;
  @Input() isClicked = false;

  onClick() {
      // Add Close button if screen width for Mobile/Tablet
      if (this.mobWidth <= '1024') {
      this.isClicked = !this.isClicked;
    }
  }

  constructor() {
    this.mobWidth = window.screen.width;
  }
}
